import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';

import 'Components/Account/ConfirmAccount.scss';

import { sendConfirmEmail, checkConfirmed } from 'Redux/ducks/auth';
import MessageBox from 'Components/Utility/MessageBox';

const messages = defineMessages({
  new_confirm: {
    id: 'confirm-account.new-confirm',
    defaultMessage: 'We have sent you a new confirmation email to {email}. Please check your email.',
  },
  new_confirm_title: {
    id: 'confirm-account.new-confirm-title',
    defaultMessage: 'Confirmation email sent',
  },
  not_confirmed: {
    id: 'confirm-account.not_confirmed',
    defaultMessage: 'Your email has not already been confirmed.',
  },
  not_confirmed_title: {
    id: 'confirm-account.not_confirmed-title',
    defaultMessage: 'Email Check Failed',
  },
  send_failed: {
    id: 'confirm-account.send_failed',
    defaultMessage: 'We could not send a new confirmatin, please try again or contact support.',
  },
  send_failed_title: {
    id: 'confirm-account.send_failed-title',
    defaultMessage: 'Email Send Failed',
  },
});

const ConfirmAccount = ({
  email,
  emailConfirmed,
  failedCheck,
  check,
  send,
  intl,
}) => {
  const [displayMsg, setDisplayMsq] = useState(false);
  const [error, setError] = useState(false);

  const { formatMessage } = intl;

  if (emailConfirmed) return false;

  const requestEmail = () => {
    send().then(() => {
      setDisplayMsq(true);
      setError(false);
    }).catch(() => {
      setError(true);
    });
  };

  return (
    <div className="confirm-account">
      {displayMsg &&
        <div className="mt-3">
          <MessageBox
            type="success"
            title={formatMessage(messages.new_confirm_title)}
            message={formatMessage(messages.new_confirm, { email })}
          />
        </div>
      }
      {failedCheck &&
        <div className="mt-3">
          <MessageBox
            type="error"
            title={formatMessage(messages.not_confirmed_title)}
            message={formatMessage(messages.not_confirmed)}
          />
        </div>
      }
      {error &&
        <div className="mt-3">
          <MessageBox
            type="error"
            title={formatMessage(messages.send_failed_title)}
            message={formatMessage(messages.send_failed)}
          />
        </div>
      }
      <div className="confirm-title p-3">
        <FormattedMessage id="account.confirm.importantinformation" defaultMessage="Important Account Information" />
      </div>
      <div className="confirm-account-content">
        <div className="confirm-content-container">
          <div className="text-container">
            <p>
              <FormattedMessage id="account.confirm.noconfirm" defaultMessage="You have not confirmed your email and are unable to redeem your keys." />
            </p>
            <p>
              <FormattedMessage id="account.confirm.followthelink" defaultMessage="Follow the link we have sent to your inbox to complete your registration." />
            </p>
          </div>
          <div className="buttons-container">
            <div className="button-container">
              <button className="btn btn-primary" onClick={requestEmail}>
                <FormattedMessage id="account.confirm.resend" defaultMessage="Resend email" />
              </button>
            </div>
            <div className="button-container">
              <button className="btn btn-secondary" onClick={check}>
                <FormattedMessage id="account.confirm.alreadyconfirmed" defaultMessage="I have already confirmed" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmAccount.propTypes = {
  email: PropTypes.string.isRequired,
  emailConfirmed: PropTypes.bool.isRequired,
  failedCheck: PropTypes.bool,
  send: PropTypes.func.isRequired,
  check: PropTypes.func.isRequired,
};

ConfirmAccount.defaultProps = {
  failedCheck: false,
};

const mapStateToProps = ({
  auth: { email, failed_check: failedCheck, email_confirmed: emailConfirmed },
}) => ({ email, failedCheck, emailConfirmed });

const mapDispatchToProps = {
  send: sendConfirmEmail,
  check: checkConfirmed,
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(ConfirmAccount));
